import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { OverviewCard } from 'components/dashboard/components/overview-card';
import ReviewTable from 'components/dashboard/components/review-table';
import ReviewList from 'components/dashboard/components/review-list';
import * as actions from 'actions/vendor-request';
import {
  FlexRow,
  Container,
  PlainButton,
  HeaderFlexRow,
  HeadingTitle,
} from 'components/styled-components';
import {
  StatContainer,
  BlueSection,
  DashboardContent,
  H2Dashboard,
} from 'components/dashboard/components/styled-components';
import colors from 'utils/colors';

const UPCOMING_RENEWALS_WITHIN_DAYS = 60;
const tableHeaders = ['Third Party Name', 'Product or Service', 'Date Created'];
const tableFields = [
  ['vendorInformation', 'vendorName'],
  ['productServiceName'],
  ['requestSubmittedDate'],
];
const renewalsHeaders = [...tableHeaders, 'Renewal Date'];
const renewalsFields = [...tableFields, ['renewalDate']];

const DashboardOverview = ({
  awaitingCompletion,
  inReview,
  passed,
  upcomingApprovals,
}) => (
    <StatContainer>
      <OverviewCard
        title="In Progress"
        icon="time"
        color={colors.icons.azure}
        data={awaitingCompletion['totalCount']}
        filterType="requestStatus"
        filter="Awaiting Third Party Completion"
      />
      <OverviewCard
        title="Needs Review"
        icon="issue"
        color={colors.icons.amber}
        data={inReview['totalCount']}
        filterType="statusCategory"
        filter={['review']}
      />
      <OverviewCard
        title="Approved"
        icon="small-tick"
        color={colors.icons.citrus}
        data={passed['totalCount']}
        filterType="statusCategory"
        filter="pass"
      />
      <OverviewCard
        title="Upcoming Renewals"
        icon="calendar"
        color={colors.icons.slate}
        data={upcomingApprovals['totalCount']}
        filter="upcoming"
      />
    </StatContainer>
  );

class DashboardAdministrator extends Component {
  componentDidMount() {
    const params = { start: 0, limit: -1, orderBy: 'requestSubmittedDate', orderDir: 'desc' };
    this.props.fetchAllVendorRequests({ ...params });
    this.props.fetchAllUpcomingRenewalVendorRequests({
      ...params,
      renewalsWithinDays: UPCOMING_RENEWALS_WITHIN_DAYS,
    });
  }

  render() {
    const {
      awaitingCompletion,
      inReview,
      passed,
      upcomingApprovals,
      belowThreshold,
      autoFailQuestions,
      autoFailDocumentation,
      appUser,
    } = this.props;

    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>Dashboard</HeadingTitle>
          <NavLink to="/new">
            <PlainButton>Create Assessment</PlainButton>
          </NavLink>
        </HeaderFlexRow>
        <BlueSection>
          <H2Dashboard>Assessments Overview</H2Dashboard>
          <DashboardOverview
            awaitingCompletion={awaitingCompletion}
            inReview={inReview}
            passed={passed}
            upcomingApprovals={upcomingApprovals}
          />
          <H2Dashboard>Assessments Needing Review</H2Dashboard>
        </BlueSection>

        <DashboardContent>
          <FlexRow flexWrap="wrap">
            <ReviewList
              title="Below Threshold"
              data={belowThreshold}
              filterType="requestStatus"
              filter="Below Threshold, Needs Review"
            />
            <ReviewList
              title="Auto Fail - Documentation"
              data={autoFailDocumentation}
              filterType="requestStatus"
              filter="Auto Fail - Documentation"
            />
            <ReviewList
              title="Auto Fail - Question(s)"
              data={autoFailQuestions}
              filterType="requestStatus"
              filter="Auto Fail - Question(s)"
            />
          </FlexRow>

          <H2Dashboard>Recent Assessments</H2Dashboard>
          <FlexRow flexWrap="wrap">
            <ReviewTable
              title="Pending Completion"
              data={awaitingCompletion}
              userRole={appUser.roleDisplayName}
              headers={tableHeaders}
              fields={tableFields}
              filterType="statusCategory"
              filter="pending"
              icon="time"
              color={colors.icons.azure}
            />
            <ReviewTable
              title="In Review"
              data={inReview}
              userRole={appUser.roleDisplayName}
              headers={tableHeaders}
              fields={tableFields}
              icon="issue"
              color={colors.icons.amber}
              filterType="statusCategory"
              filter="review"
            />
          </FlexRow>
          <H2Dashboard>
            Assessments Up for Renewal in the Next{' '}
            {UPCOMING_RENEWALS_WITHIN_DAYS} Days
          </H2Dashboard>
          <FlexRow flexWrap="wrap">
            <ReviewTable
              title="Upcoming Renewals"
              data={upcomingApprovals}
              userRole={appUser.roleDisplayName}
              headers={renewalsHeaders}
              fields={renewalsFields}
              filter="upcoming"
              icon="calendar"
              color={colors.icons.slate}
            />
          </FlexRow>
        </DashboardContent>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  awaitingCompletion: state.vendorRequest.allRequestsInProgress,
  inReview: state.vendorRequest.allRequestsInReview,
  passed: state.vendorRequest.allRequestsPassed,
  upcomingApprovals: state.vendorRequest.allRequestsUpcomingApprovals,
  belowThreshold: state.vendorRequest.allRequestsBelowThreshold,
  autoFailQuestions: state.vendorRequest.allRequestsAutoFailQuestions,
  autoFailDocumentation: state.vendorRequest.allRequestsAutoFailDocumentation,
});

DashboardAdministrator = connect(
  mapStateToProps,
  actions
)(DashboardAdministrator);

export default DashboardAdministrator;
